// pages/VoyageursAeriens.jsx
import React, { useState } from 'react';
import { 
    Search, 
    FileDown,
    RefreshCw,
    Home, 
    Plane, 
    Car, 
    CreditCard
} from 'lucide-react';
import SidebarAdmin from './superdashboard/SideBarAdmin';
import MobileNavigationAdmin from './superdashboard/MobileNavigationAdmin';
import DashboardHeaderAdmin from './superdashboard/DashboardHeaderAdmin';
import useGlobale from '../components/global';
import AdminMenu from '../components/AdminMenu';

export default function VoyageursAeriens() {
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const { user } = useGlobale();
    const [filters, setFilters] = useState({
        type: 'tous', 
        dateDebut: '',
        dateFin: '',
        provenance: '',
        genre: 'tous'
    });

    // Données de démonstration
    const voyageurs = [
        {
            id: 1,
            nom: "Moussa Ibrahim",
            passport: "N1234567",
            type: "Entrée",
            date: "2024-03-15",
            vol: "ET507",
            provenance: "Addis-Abeba",
            destination: "Niamey",
            genre: "Homme",
            nationalite: "Nigérien",
            status: "Validé"
        },
        {
            id: 2,
            nom: "Aisha Mohammed",
            passport: "N7654321",
            type: "Sortie",
            date: "2024-03-15",
            vol: "AF982",
            provenance: "Niamey",
            destination: "London",
            genre: "Femme",
            nationalite: "Nigérienne",
            status: "En cours"
        },
        {
            id: 3,
            nom: "John Smith",
            passport: "A9876543",
            type: "Entrée",
            date: "2024-03-16",
            vol: "KL523",
            provenance: "Amsterdam",
            destination: "Niamey",
            genre: "Homme",
            nationalite: "Américain",
            status: "Validé"
        },
        {
            id: 4,
            nom: "Fati Mahamadou",
            passport: "N8765432",
            type: "Sortie",
            date: "2024-03-16",
            vol: "MS612",
            provenance: "Niamey",
            destination: "Le Caire",
            genre: "Femme",
            nationalite: "Nigérienne",
            status: "En cours"
        }
    ];

    const handleExport = () => {
        console.log('Exporting data...');
    };

    return (
        <div className="flex min-h-screen bg-[#F4F8E9]">
            <SidebarAdmin
                isOpen={isSidebarOpen}
                menuItems={AdminMenu}
                onClose={() => setIsSidebarOpen(false)}
            />

            <div className="flex-1">
                <DashboardHeaderAdmin
                    isSidebarOpen={isSidebarOpen}
                    setIsSidebarOpen={setIsSidebarOpen}
                    user={user}
                />

                <main className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-8 pb-20 lg:pb-8">
                    {/* En-tête */}
                    <div className="flex justify-between items-center mb-6">
                        <div>
                            <h1 className="text-2xl font-bold text-[#437011]">Liste des Voyageurs Aériens</h1>
                            <p className="text-gray-600">Gestion et suivi des voyageurs</p>
                        </div>
                        <div className="flex space-x-3">
                            <button 
                                onClick={handleExport}
                                className="flex items-center px-4 py-2 bg-[#96B734] text-white rounded-lg hover:bg-[#437011] shadow-md hover:shadow-lg transition-all"
                            >
                                <FileDown className="w-4 h-4 mr-2" />
                                Exporter
                            </button>
                            <button 
                                className="flex items-center px-4 py-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700 shadow-md hover:shadow-lg transition-all"
                            >
                                <RefreshCw className="w-4 h-4 mr-2" />
                                Actualiser
                            </button>
                        </div>
                    </div>

                    {/* Filtres */}
                    <div className="bg-white p-4 rounded-xl shadow-lg mb-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Type de voyage</label>
                                <select 
                                    className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#96B734] focus:border-transparent"
                                    value={filters.type}
                                    onChange={(e) => setFilters({...filters, type: e.target.value})}
                                >
                                    <option value="tous">Tous</option>
                                    <option value="entree">Entrée</option>
                                    <option value="sortie">Sortie</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Date de début</label>
                                <input 
                                    type="date" 
                                    className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#96B734] focus:border-transparent"
                                    value={filters.dateDebut}
                                    onChange={(e) => setFilters({...filters, dateDebut: e.target.value})}
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Date de fin</label>
                                <input 
                                    type="date" 
                                    className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-[#96B734] focus:border-transparent"
                                    value={filters.dateFin}
                                    onChange={(e) => setFilters({...filters, dateFin: e.target.value})}
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Recherche</label>
                                <div className="relative">
                                    <input 
                                        type="text" 
                                        placeholder="Rechercher..."
                                        className="w-full border rounded-lg pl-10 pr-3 py-2 focus:ring-2 focus:ring-[#96B734] focus:border-transparent"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Nom & Passeport
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Type
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Vol & Date
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Provenance/Destination
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Genre
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Nationalité
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Status
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {voyageurs.map((voyageur) => (
                                        <tr key={voyageur.id} className="hover:bg-gray-50">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-medium text-gray-900">{voyageur.nom}</div>
                                                <div className="text-sm text-gray-500">{voyageur.passport}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                                    voyageur.type === 'Entrée' 
                                                        ? 'bg-[#96B734] text-white' 
                                                        : 'bg-brand-600 text-white'
                                                }`}>
                                                    {voyageur.type}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">{voyageur.vol}</div>
                                                <div className="text-sm text-gray-500">{voyageur.date}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">
                                                    {voyageur.type === 'Entrée' ? voyageur.provenance : voyageur.destination}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {voyageur.genre}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {voyageur.nationalite}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                                    voyageur.status === 'Validé' 
                                                        ? 'bg-[#96B734] text-white' 
                                                        : 'bg-yellow-500 text-white'
                                                }`}>
                                                    {voyageur.status}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <div className="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
                            <div className="flex justify-between items-center">
                                <div className="text-sm text-gray-700">
                                    Affichage de <span className="font-medium">1</span> à <span className="font-medium">10</span> sur{' '}
                                    <span className="font-medium">97</span> résultats
                                </div>
                                <div className="flex space-x-2">
                                    <button 
                                        className="px-3 py-1 border border-[#96B734] rounded-lg text-sm font-medium text-[#437011] hover:bg-[#F4F8E9] transition-colors"
                                        onClick={() => setCurrentPage(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Précédent
                                    </button>
                                    <button 
                                        className="px-3 py-1 border border-[#96B734] rounded-lg text-sm font-medium text-[#437011] hover:bg-[#F4F8E9] transition-colors"
                                        onClick={() => setCurrentPage(currentPage + 1)}
                                    >
                                        Suivant
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>

                <MobileNavigationAdmin menuItems={AdminMenu} />
            </div>
        </div>
    );
}